export default __webpack_public_path__ + "media/color/gusd-1829f2be.svg";